export default __webpack_public_path__ + "static/media/Cattura14.fb946817.jpg";